<template>
  <div>
    <v-toolbar
      dark
      color="primary"
    >
      <v-btn
        icon
        dark
        @click="closeDialog"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>Settings</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn
          dark
          text
          @click="save"
        >
          Save
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-form>
      <v-text-field v-if="isEdit" v-model="currentQuestionId" readonly label="Unieke vraag id"></v-text-field>
      <v-text-field v-else v-model="newQuestionId" label="Unieke vraag id" :rules="[rules.uniqueId]"></v-text-field>
      <v-text-field v-model="question" label="Wat is de vraag?"></v-text-field>
      <v-switch v-model="isMandatoryQuestion" label="Verplichte vraag"></v-switch>
      <v-select
        v-model="selectedType"
        :items="questionTypes"
        label="Selecteer vraagtype"
        @change="updateOptions"
      ></v-select>
      <v-container v-if="hasOptions"> <!-- list options and remove option -->
        <v-row v-for="(option, optionIndex) in options" v-bind:key="option.id">
          <v-col
            cols="12"
            md="3">
            <v-subheader>{{ option.key }}</v-subheader>
          </v-col>
          <v-col
            cols="12"
            md="4">
            <v-subheader>{{ option.caption }}</v-subheader>
          </v-col>
          <v-col
            cols="12"
            md="4">
            <v-select v-model="options[optionIndex].forwardTo" :items="forwardIds" item-text="question"
                      item-value="id" clearable label="doorsturen naar" v-if="isForwardable" />
          </v-col>
          <v-col
            cols="12"
            md="1">
            <v-btn color="primary" icon @click="removeOption(optionIndex)">
              <v-icon>mdi-minus-thick</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-if="hasOptions"> <!-- add option -->
        <v-row>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field v-model="addOptionId" label="Optie id"></v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field v-model="addOptionLabel" label="Optie label"></v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="4"
          ></v-col>
          <v-col
            cols="12"
            md="1"
          >
            <v-btn color="primary" icon @click="addOption" :disabled="!addOptionId">
              <v-icon>mdi-plus-thick</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-snackbar
      v-model="showSnackbar"
      :timeout="2000"
    >
      Dubbele optie id is niet toegestaan
      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="showSnackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <question-card v-if="selectedType" :question="renderedPreview"></question-card>
  </div>
</template>

<script>
import QuestionCard from '../QuestionCard';
import {mapGetters} from 'vuex';
import {questionService} from '@/services/question';
import {Question} from '@/shared/question';

const CHECKBOX = 'Checkbox';
  const NUMBER = 'Number';
  const PHOTO = 'Photo';
  const RADIO = 'Radio';
  const SELECT = 'Select';
  const SIGNATURE = 'Signature';
  const TELEPHONE = 'Telephone';
  const TEXT = 'Text';

  export default {
    name: 'question-builder',
    components: { QuestionCard },
    props: {
      survey: [],
      questionId: String,
      value: Boolean,
      isEdit: Boolean,
    },
    data() {
      return {
        questionTypes: [CHECKBOX, NUMBER, PHOTO, RADIO, SELECT, SIGNATURE, TELEPHONE, TEXT],
        newQuestionId: '',
        currentQuestionId: '',
        question: null,
        selectedType: null,
        questionPreview: null,
        showSnackbar: false,
        isMandatoryQuestion: false,
        optionText: '',
        addOptionId: '',
        addOptionLabel: '',
        options: [],
        forwardIds: [],
        rules: {
          uniqueId: value => !this.survey.some(q => q.id === value),
        },
      };
    },
    methods: {
      save() {
        // clientId,surveyId, selectedId,
        // - questionId
        // - questionType
        // - question
        if (this.hasOptions && !this.isEdit) {
          const requestOptions = this.options.map(o => {
            return { 'key': o.key, 'caption': o.caption, 'forwardTo': o.forwardTo };
          });

          const request = {
            'afterQuestionId': this.selectedId,
            'newQuestionId': this.newQuestionId,
            'questionType': this.renderedPreview.type,
            'required': this.isMandatoryQuestion,
            'question': this.question,
            'options': requestOptions,
          };
          questionService.addQuestion(this.selectedClient, this.selectedSurvey, request)
            // eslint-disable-next-line no-unused-vars
            .then(response => this.closeDialog());
        } else if (this.hasOptions && this.isEdit) {
          const requestOptions = this.options.map(o => {
            return { 'key': o.key, 'caption': o.caption, 'forwardTo': o.forwardTo };
          });

          const request = {
            'questionId': this.currentQuestionId,
            'questionType': this.renderedPreview.type,
            'question': this.question,
            'required': this.isMandatoryQuestion,
            'options': requestOptions,
          };

          questionService.changeQuestion(this.selectedClient, this.selectedSurvey, this.currentQuestionId, request)
            // eslint-disable-next-line no-unused-vars
            .then(response => this.closeDialog());
        } else {
          let questionId;
          if (this.isEdit) {
            questionId = this.currentQuestionId;
          } else {
            questionId = this.newQuestionId;
          }
          const request = {
            'questionId': questionId,
            'questionType': this.renderedPreview.type,
            'required': this.isMandatoryQuestion,
            'question': this.question,
          };

          questionService.changeQuestion(this.selectedClient, this.selectedSurvey, questionId, request)
            // eslint-disable-next-line no-unused-vars
            .then(response => this.closeDialog());
        }
      },
      closeDialog() {
        this.$parent.$parent.$parent.$parent.$emit('renderquestionflow');
        this.$emit('input', false);
      },
      addOption() {
        if (this.options.find(opt => opt.key === this.addOptionId)) {
          this.showSnackbar = true;
          return;
        }
        this.options.push({ 'key': this.addOptionId, 'caption': this.addOptionLabel });
        this.addOptionId = '';
        this.addOptionLabel = '';
      },
      removeOption(i) {
        this.options.splice(i, 1);
      },
      updateOptions() {
        if (this.selectedType === TEXT) {
          this.optionText = '';
        }
      },
      firstLetterToUpperCase(stringToFirstCap) {
        return stringToFirstCap[0].toUpperCase() + stringToFirstCap.slice(1);
      },
      initLoad() {
        if (this.isEdit) {
          this.currentQuestionId = this.questionId;
          this.forwardIds = [];
          questionService.resolveFutureQuestions(this.selectedClient, this.selectedSurvey, this.questionId)
            .then(response => this.forwardIds = response.data);
          this.survey
            .filter(q => q.id === this.questionId)
            .forEach(q => { // only one result, but the id is unique
              this.question = q.question;
              this.selectedType = this.firstLetterToUpperCase(q.type);
              this.questionPreview = q;
              this.isMandatoryQuestion = q.required;
              this.options = q.options;
            });
        } else {
          this.newQuestionId = Math.random().toString(16).slice(2, 7);
          this.forwardIds = [];
          questionService.resolveFutureQuestions(this.selectedClient, this.selectedSurvey, this.questionId)
            .then(response => this.forwardIds = response.data);
          this.question = null;
          this.isMandatoryQuestion = false;
          this.selectedType = null;
          this.questionPreview = null;
          this.options = [];
        }
      },
    },
    watch: {
      // eslint-disable-next-line no-unused-vars
      value(newVal, oldVal) {
        if (newVal) {
          this.initLoad();
        }
      },
      // eslint-disable-next-line no-unused-vars
      selectedType(newVal, oldVal) {
        if (newVal === TEXT || newVal === CHECKBOX) {
          this.options = [];
        }
      },
    },
    computed: {
      ...mapGetters(['selectedClient', 'selectedSurvey', 'selectedId']),
      hasOptions() {
        return this.selectedType === RADIO || this.selectedType === SELECT || this.selectedType === CHECKBOX;
      },
      isForwardable() {
        return this.selectedType === RADIO || this.selectedType === SELECT;
      },
      renderedPreview() {
        let response = {};
        switch (this.selectedType) {
          case TEXT:
            response = Question.initText();
            break;
          case RADIO:
            response = Question.initRadio();
            break;
          case SELECT:
            response = Question.initSelect();
            break;
          case CHECKBOX:
            response = Question.initCheckBox();
            break;
          case PHOTO:
            response = Question.initPhoto();
            break;
          case SIGNATURE:
            response = Question.initSignature();
            break;
          case NUMBER:
            response = Question.initNumber();
            break;
          case TELEPHONE:
            response = Question.initTelephone();
            break;
        }
        response.id = this.questionId;
        response.question = this.question;
        if (this.options) {
          const options = this.options.map(e => e.caption);
          response.addOptions(options);
        }
        return response;
      },
    },
    created() {
      this.initLoad();
    },
  };

</script>